import React, { Component } from 'react';
import { Modal,Button } from 'react-bootstrap';
import { dispatch, connect } from 'react-redux';
import { clearUser,signOut} from '../actions/creators';
import { Redirect } from 'react-router';
require('es6-promise').polyfill();
require('isomorphic-fetch');



class SignDocument extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            value:"status",
            redirect:false,
            modalContent:'',
            signed:false
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.btnTapped=this.btnTapped.bind(this);
        this.parseResponse = this.parseResponse.bind(this);
    }

    async parseResponse(response) {
        var responseText = '';
        await response.text().then(function (data) {
            responseText = data;

            return data;
        });

        if (response.status == "200") {
            this.setState({modalContent: "Your signature response has been recorded.",signed:true});
        }

        if (responseText == "DOL- Signature is invalid.") {
            this.setState({modalContent: "The UserID or PIN are invalid per the EFAST2 registration system .  Please click on \"Forgot your UserID or PIN\" to verify your signature credentials."});
        }

        if (responseText == "Token mismatch found") {
            this.setState({modalContent: "Token has expired. Kindle login again!",redirect:true});
        }

        if (response.status == "500") {
            this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
        }
    //    this.handleShow();
        return responseText;
    }

    ValidateUserId(mail) {
        if (/[A-Z][0-9]{7}$/.test(mail)) {
            return (true)
        }
        return (false)
    }


    btnTapped(signStatus) {
        var isFormDataValid = true;
        var userId = document.getElementById("username").value.toString();
        var pin = document.getElementById("pin").value.toString();
        var repin = document.getElementById("repin").value.toString();
        var comment = document.getElementById("comment").value.toString();

        if ( repin != pin) {
            isFormDataValid = false;
            this.setState({modalContent: 'PIN  entries do not match'});
            this.handleShow();
        }

        if (pin == "") {
            isFormDataValid = false;
            this.setState({modalContent: 'Please enter a valid PIN'});
            this.handleShow();
        }

        if (userId == "") {
            isFormDataValid = false;
            this.setState({modalContent: 'Please enter a valid user ID'});
            this.handleShow();
        }
        else{
            if(!this.ValidateUserId(userId)){
                isFormDataValid = false;
                this.setState({modalContent: 'Please enter a valid user ID'});
                this.handleShow();
            }
        }


        if (isFormDataValid) {
            var url = this.props.serverUrl + '/v1/document-download/updateStatus?intuit_apikey=preprdakyresHjYaHW1MEBflTsUGE3wXYPFbG4AM';
            fetch(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: "PUT",
                    body: JSON.stringify({
                        email: this.props.email,
                        year: this.props.year,
                        planId: this.props.planId,
                        planEin: this.props.planEin,
                        returnStatus: this.props.returnStatus,
                        documentName: this.props.documentName,
                        taxReturnId: this.props.taxReturnId,
                        token: this.props.token,
                        realmId: this.props.realmId,
                        userId: userId,
                        pin: pin,
                        signStatus: signStatus,
                        comment: comment
                    })
                }
            )
                .then(response => {
                    let clone = response.clone();
                    this.handleShow(this.parseResponse(clone));

                })
                .catch(error => {
                    this.setState({modalContent: 'Something went wrong ! Kindly try again'});
                    this.handleShow();
                });
        }
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
        if(this.state.redirect == true){
            this.props.clearUser(this.state);
        }
        if(this.state.signed == true){
            this.props.signOut(this.state);
        }

    }


    render() {

        return (


            <div>

               <font size="5" color="green"><b>Signing As:</b></font>
                <font size="4">  {this.props.role}</font><br />
                <font size="4">   Comment: </font><br />
                <textarea rows="4" cols="50" className="cln" name="comment" id="comment" maxlength="100"/><br />
                <font size="4"> To sign the return enter the EFAST2 credentials obtained by registering at:</font><br />
                <a href="https://www.efast.dol.gov/welcome.html" target="_blank">www.efast.dot.gov</a><br /><br />
                    <table>
                        <tbody>
                        <tr align="left">
                            <td className="right"> <label htmlFor="username">UserId:</label></td>
                            <td className="left"><input id="username" name="username" type="text" maxlength = "8"/></td>
                        </tr>
                        <tr>
                            <td className="right"><label htmlFor="email">PIN:</label></td>
                            <td className="left"><input id="pin" name="pin" type="password" maxlength = "4"/></td>
                        </tr>
                        <tr>
                            <td className="right"><label htmlFor="birthdate">Re-enterPIN:</label></td>
                            <td className="left"><input id="repin" name="repin" type="password" maxlength = "4"/><br /></td>
                        </tr>
                        </tbody>
                    </table>
                    <a href="https://www.efast.dol.gov/portal/app/login" target="_blank">Forgot your UserId or PIN?</a> <br />
                    <button style={{marginTop:5}} type="submit" id="accept" value="Sign" className="sign-btn" name="accept" onClick={e => this.btnTapped("SIGNED")}>Sign</button>
                    &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;
                    <button style={{marginTop:5}}type="submit" id="reject" value="Reject" className="reject-btn" name="reject"  onClick={e => this.btnTapped("REJECTED")}>Reject</button>

                <Modal show={this.state.show} onHide={this.handleClose} animation={false}>

                    <Modal.Body>{this.state.modalContent}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12 text-center">
                            <Button variant="secondary" bsClass="close-button" onClick={this.handleClose}>
                                Close
                            </Button>
                        </div>

                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = ( state ) => {
    return {
        userName:state.userName,
        email:state.email,
        login:state.login,
        planEin:state.planEin,
        planId:state.planId,
        year:state.taxYear,
        token:state.token,
        realmId:state.realmId,
        documentName:state.documentName,
        taxReturnId:state.taxReturnId,
        role:state.role,
        serverUrl:state.serverUrl
    }
};

const mapDispatchToProps = dispatch => {
    return {
        clearUser: (state) => {
            dispatch(clearUser(state))
        },
        signOut: (state) => {
            dispatch(signOut(state))
        }

    };
};

export default connect(mapStateToProps,mapDispatchToProps)(SignDocument);
